import React, { Component } from "react";

import mascopirometbomen from "../../Images/H5_Mascopiro_met_bomen.png";

import "./HetWoudRedden.scss";

class HetWoudRedden extends Component {
  render() {
    return (
      <div className="het-woud-redden">
        <img src={mascopirometbomen} alt="" />
        <div className="text">
          Teken een boom die jullie niet in België tegenkomen en schrijf er op hoe jij je steentje kan bijdragen om het Amazonewoud te redden. <br /><br />Plak daarna al jullie bomen samen om een nieuw bos te maken om in de klas te hangen!
          <br />
          Je kan hiervoor onze <a href="/poster.pdf" target="_blank">poster</a> gebruiken.
        </div>
      </div>
    );
  }
}

export default HetWoudRedden;
